exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2I0F2{margin-bottom:20px}._3DEYy{position:relative}.K2GWo{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._1VCyV,.K2GWo{display:-webkit-box;display:-ms-flexbox;display:flex}._1VCyV{-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px;margin-bottom:20px}._1VCyV>div{margin-bottom:10px;margin-top:10px}._3coG7{height:100%}", ""]);

// exports
exports.locals = {
	"gptPremium": "_2I0F2",
	"flexCell": "_3DEYy",
	"sideBar": "K2GWo",
	"advertContainerButoon": "_1VCyV",
	"homeSideBar": "_3coG7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/BannerAll/BannerAll.css
// module id = 1300
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46